import type { ApprovalRequest } from '@/lib/types';
import { BucketShell } from './_BucketShell';
import { readStructuredFields } from './_payload';

export interface ExpenseRebateReviewViewProps {
  req: ApprovalRequest;
}

export function ExpenseRebateReviewView({ req }: ExpenseRebateReviewViewProps) {
  const fields = readStructuredFields(req) as Record<string, unknown>;
  const reason =
    typeof fields['review_reason'] === 'string' && fields['review_reason'].trim()
      ? fields['review_reason'].trim()
      : 'Exp/Reb lines were detected but the Oracle accounting allocation is incomplete.';

  return (
    <BucketShell req={req}>
      <section className="rounded-lg border border-orange-300 bg-orange-50 p-16">
        <p className="text-xs font-semibold uppercase tracking-wide text-orange-800">
          Exp/Reb review
        </p>
        <p className="mt-4 text-sm text-neutral-700">
          {reason} Finance must choose the Oracle Exp/Reb and charged-to codes before
          this goods invoice can be validated for posting.
        </p>
        <p className="mt-12 text-sm text-neutral-600">
          Use the Exp/Reb rows below and the correction form&apos;s LOV fields to complete
          the accounting allocation. Subtotal, tax, and invoice gross stay as the
          supplier invoice amounts; Exp/Reb is checked separately by the Oracle writer.
        </p>
      </section>
    </BucketShell>
  );
}
